import React from "react";
import "./objDisplay.css";

const ObjDisplay = ({ data }) => {
  return (
    <div className="kv-container">
      {Object.entries(data).map(([key, value]) => (
        <div key={key} className="kv-row">
          <strong className="kv-key">{key}:</strong>
          <div className="kv-value">{String(value)}</div>
        </div>
      ))}
    </div>
  );
};

export default ObjDisplay;
